// web/shims/BottomSheetShim.tsx
//
// `@gorhom/bottom-sheet`'s `BottomSheetTextInput` relies on native internals + `findNodeHandle`.
// On web (react-native-web + React 19), unmount can crash with:
// "Cannot read properties of null (reading '_scrollRef')" coming from findNodeHandle.web.js.
//
// We keep the real bottom-sheet implementation, but replace ONLY BottomSheetTextInput
// with a plain react-native TextInput on web.

import React from 'react';
import { TextInput, type TextInputProps } from 'react-native';

// IMPORTANT: import the real module via subpath so webpack alias for "@gorhom/bottom-sheet"
// (this file) doesn't recurse.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const BS = require('@gorhom/bottom-sheet-real');

export const BottomSheetModal = BS.BottomSheetModal;
export const BottomSheetModalProvider = BS.BottomSheetModalProvider;
export const useBottomSheetModal = BS.useBottomSheetModal;

export const BottomSheetBackdrop = BS.BottomSheetBackdrop;
export const BottomSheetFooter = BS.BottomSheetFooter;
export const BottomSheetScrollView = BS.BottomSheetScrollView;
export const BottomSheetView = BS.BottomSheetView;
export const BottomSheetFlatList = BS.BottomSheetFlatList;

// Keep a ref-capable component so existing call sites don't change.
export const BottomSheetTextInput = React.forwardRef<TextInput, TextInputProps>(
  (props, ref) => <TextInput ref={ref} {...props} />,
);
BottomSheetTextInput.displayName = 'BottomSheetTextInput';

// If any code relies on other exports, they still come from the real package (via named imports),
// because we keep your app imports unchanged; this shim is only for webpack runtime resolution.
export default BS.default ?? BS;
